import { useState } from 'react';
import type { MasterFileSummary } from '@/types/packageSummary';
import { TechnicalColumn, AudioColumn, ProjectFilesColumn } from './MetadataColumns';

interface MasterFileRowProps {
  masterFile: MasterFileSummary;
}

/**
 * Collapsible row displaying metadata for a single master file
 */
export const MasterFileRow = ({ masterFile }: MasterFileRowProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden mb-3">
      {/* Collapsed Header - Shows filename only */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 bg-white hover:bg-gray-50 flex items-center justify-between transition-colors"
      >
        <div className="flex items-center gap-3">
          <svg
            className={`w-5 h-5 text-gray-500 transition-transform ${
              isExpanded ? 'rotate-90' : ''
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
          <div className="text-left">
            <div className="font-medium text-gray-900">{masterFile.filename}</div>
            <div className="text-xs text-gray-500">{masterFile.file_path}</div>
          </div>
        </div>
      </button>

      {/* Expanded Content - Shows 3-column metadata grid */}
      {isExpanded && (
        <div className="px-4 py-4 bg-gray-50 border-t border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <TechnicalColumn technical={masterFile.technical} />
            <AudioColumn audio={masterFile.audio} />
            <ProjectFilesColumn projectFiles={masterFile.project_files} />
          </div>
        </div>
      )}
    </div>
  );
};
